export default {
    notifList: [],
    initiateAwal: false
}
